import React, { Component } from 'react';
import { connect } from 'react-redux';
import Heading from '../../Component/UI/Heading';
// import HeatMapBlock from '../Charts/HeatMapBlock';
// import { MdOutlineFileDownload } from "react-icons/md";
// import { MdOutlineClose } from "react-icons/md";
// import html2canvas from 'html2canvas';

class RankMap extends Component {
  constructor(props) {
    super(props);
    this.pdfExportComponent = React.createRef();
    this.state = {
      showMainPage: true,
      showFilter: false,
      showValue: '',
      showTabView: 2,
      showModalDownload: false
    }
  }
  componentDidMount() {

  }

  render() {

    let { list = [] } = this.props;

    return (
      <>
        <div className=''>
          <div className="flex items-center justify-between pb-5">
            <Heading className="text-xl" title="Overall Dominant Talents Rank" />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {list.map((bucketItem, bIndex) => (
              <div
                key={bIndex}
                className="bg-white rounded-xl shadow-sm border border-[#D1D5DB] p-6"
              >
                {/* Header */}
                <div className="flex justify-between items-center mb-6">
                  <h2 className="text-xl font-medium textblack">
                    {bucketItem.bucket}
                  </h2>
                  <span className="text-xl font-medium textblack">Rank</span>
                </div>

                {/* Talents */}
                {bucketItem.dimensions
                  ?.slice(0, bucketItem.showCount)
                  .map((talent, tIndex) => (
                    <div key={tIndex} className="flex items-center gap-4 mb-4">

                      {/* Talent name */}
                      <div className="w-36 text-lg font-medium textblack">
                        {talent.name}
                      </div>

                      {/* Progress bar */}
                      <div className="flex-1 h-7 bg-gray-100 overflow-hidden rounded-full">
                        <div
                          className="h-full rounded-full"
                          style={{
                            width: (((talent.rank * 100)) / 28).toString() + "%",
                            backgroundColor: bucketItem.colorCode
                          }}
                        />
                      </div>

                      {/* Rank */}
                      <div
                        className="min-w-[40px] text-center text-sm font-medium px-2 py-1.5 rounded-full"
                        style={{
                          backgroundColor: `${bucketItem.colorCode}22`,
                          color: bucketItem.colorCode
                        }}
                      >
                        {talent.rank}
                      </div>
                    </div>
                  ))}
              </div>
            ))}
          </div>
        </div>
      </>
    );

  }
}
function mapStateToProps(state) {
  // ////console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { users, dashboard } = state;
  return {
    loggingIn,
    users,
    dashboard
  };
}
export default connect(mapStateToProps)(RankMap);
